import React from 'react';

const UploadArrow = () => {
  return (
    <svg aria-hidden='true' height='60px' viewBox='0 0 26 31' width='26px'>
      <path
        d='M13 .53l-2.03 1.89-11 10 4.06 4.44L10 11.42v19.22h6V11.42l5.97 5.44c.03.02 4.06-4.44 4.06-4.44l-11-10c-.4-.36-1.07-1-2.03-1.9z'
        fill='rgba(4, 69, 175, 0.3)'
      ></path>
    </svg>
  );
};

export default UploadArrow;
